import React, { useEffect, useState } from 'react';

import { PageHeader, Skeleton } from 'antd';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { getOcppTagsCards } from '../../hooks/ocpptags';
import { getTenants } from '../../hooks/tenants';
import { getUsersDashboard } from '../../hooks/users';
import OcppTagForm from '../organisms/OcppTagForm';

const OcppTagsCreatePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const OcppTagsCreatePage = () => {
  const [ocppTags, setOcppTags] = useState({});
  const [usersList, setUsersList] = useState({});
  const [tenants, setTenants] = useState({});
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      if (!Object.keys(ocppTags).length) setOcppTags(await getOcppTagsCards('USER'));
      if (!Object.keys(usersList).length) {
        const { userDashboardList } = await getUsersDashboard(true, 1, 30000);
        setUsersList(userDashboardList);
      }
      if (!Object.keys(tenants).length) setTenants(await getTenants());
      setLoading(false);
    })();
  }, []);

  const initialValues = {
    id_tag: '',
    note: '',
    owner_user_pk: null,
    parent_id_tag: null,
    type: 'CARD',
    isFreeRecharge: false,
  };

  return (
    <OcppTagsCreatePageWrapper>
      <PageHeader className='site-page-header' onBack={() => history.goBack()} title={T('Creating OCPP Tag')} />
      <OcppTagForm
        initialValues={initialValues}
        loading={loading}
        ocppTags={ocppTags}
        usersList={usersList}
        tenants={tenants}
        type='create'
      />
    </OcppTagsCreatePageWrapper>
  );
};

export default OcppTagsCreatePage;
